import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProcessChampConditionDetails, ProcessEnregistrementPayload, ProcessMailModelSelection, ProcessParametrage } from 'src/app/models/process/process-parametrage';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class ProcessService {
  private configService = inject(ConfigService);
  private readonly baseUrlApi = this.configService.config.urlApi;

  constructor(private http: HttpClient) { }
 
  public getProcesses(): Observable<any> {
    return this.http.get<any>(`${this.baseUrlApi}/api/pr/Process`);
  }

  public getProcessesParametrage(): Observable<ProcessParametrage> {
    return this.http.get<ProcessParametrage>(`${this.baseUrlApi}/api/pr/ParametrageProcess`);
  }

  public getProcess(id: number): Observable<any> {
    return this.http.get<any>(`${this.baseUrlApi}/api/pr/Process/${id}`);
  }

  public getChampConditionDetails(idChamp: number): Observable<ProcessChampConditionDetails> {
    return this.http.get<ProcessChampConditionDetails>(
      `${this.baseUrlApi}/api/pr/ParametrageProcess/champ/${idChamp}`
    );
  }

  public getMailModelSelection(entitesIds: number[]): Observable<ProcessMailModelSelection[]> {
    let queryParams = new   HttpParams();
    entitesIds.forEach(id => {
      queryParams = queryParams.append('entiteIds', id.toString());
    });
    return this.http.get<ProcessMailModelSelection[]>(`${this.baseUrlApi}/api/pr/ModelesMail`, { params: queryParams });
  }

  public createProcess(process: ProcessEnregistrementPayload): Observable<ProcessEnregistrementPayload> {
    return this.http.post<ProcessEnregistrementPayload>(
      `${this.baseUrlApi}/api/pr/Process`,
      process
    );
  }

  public updateProcess(process: ProcessEnregistrementPayload): Observable<ProcessEnregistrementPayload> {
    return this.http.put<ProcessEnregistrementPayload>( `${this.baseUrlApi}/api/pr/Process`, process);
  }

  public deleteProcess(idProcess: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrlApi}/api/pr/Process/DeleteProcess/${idProcess}`);
  }

  public setProcessActivation(idProcess: number, actif: boolean): Observable<void> {
    return this.http.post<void>(`${this.baseUrlApi}/api/pr/Process/DesactivatedProcess`, {
      id: idProcess,
      actif,
    });
  }
}
